import React, { useState, useEffect, createRef, useContext } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import "./verifyCode.scss";
// import SignUpHeader from "components/SignUpHeader/index";
import Button from "components/Button/index";
import Success from "components/success/index";

import mailSent from "assets/images/success/mailSent.svg";
import { signInContext } from "context/SigninContext";
import { useToast } from "components/Toaster/index";
import { signInWithPassword, Organization, ManageUser as MU, StoragePlan } from "@induz/sdk";
import { getUserTypeFromUser, getUserTypeSessionValue } from "utils/helperFunction";
// import { signupContext } from "context/SignupContext";
const VerifyCode = ({
  nextStep,
  title = "Enter TOTP",
  description = "",
  btnText = "Verify code",
  isReset = false,
  checkMail = false,
  setStep,
  mailData = {},
  setMailData = () => { },
  signin = false,
  setSigninSuccess,
  checkAuth = false,
  ids
}) => {
  const location = useLocation();
  const navigate = useNavigate();
  const [count] = useState(6);
  const [otp, setOtp] = useState("");
  const [showError, setShowError] = useState(false);
  const [success, setSuccess] = useState(false);
  // const isTypeSelect = location.state?.isTypeSelect;
  // const isReset = location.state?.isReset;
  // const successSignin = location.state?.successSigninMsg;
  // const OTP = "123456";
  const { formData, isTypeSelect, setIsTypeSelect, setUserMail, setFormData } =
    useContext(signInContext);
  const { setUser, setOrgnization, addPinSelect } = useContext(signInContext);
  // const { setUser, setPlan, setAuthToken, setOrgnization } = useContext(signInContext);
  // const { formData: signupFormData } = useContext(signupContext);
  const [refs] = useState(
    Array(count)
      .fill(1)
      .map(() => createRef())
  );

  // const showSuccess = () => {
  //   if (Number(OTP) === Number(otp)) {
  //     setSuccess(true);
  //     if (isTypeSelect === "org") {
  //       navigate("/organizationprofile");
  //     }

  //     // setTimeout(() => {
  //     //   setSuccess(false);
  //     // }, 2000);
  //   }
  // };

  // const updateOtpState = () => {
  //   const otpValue = refs.map((ref) => ref.current.value || "").join("");
  //   setOtp(otpValue);

  //   if (otpValue.length === 0) {
  //     setShowError(false);
  //   }
  // };

  const updateOtpState = () => {
    const otpValue = refs.map((ref) => ref.current.value || "").join("");
    setOtp(otpValue);
  };

  // const handleChange = (val, ref, idx) => {
  //   //  if (OTP[idx] !== val) {
  //   //    setShowError(true);
  //   //  } else {
  //   //    setShowError(false);
  //   //  }

  //   if (isNaN(val)) {
  //     ref.current.value = "";
  //     return;
  //   }

  //   if (val) {
  //     if (idx < count - 1) {
  //       refs[idx + 1].current.focus();
  //     } else {
  //       ref.current.blur();
  //     }
  //   }

  //   if (showError) {
  //     setShowError(false); // Remove error when user starts typing again
  //   }
  //   updateOtpState();
  // };

  // const handleChange = (val, ref, idx) => {
  //   if (isNaN(val)) {
  //     ref.current.value = "";
  //     return;
  //   }

  //   const updatedOtp = [...otp];
  //   updatedOtp[idx] = val;

  //   setOtp(updatedOtp.join("")); // Ensures all characters are stored properly

  //   if (val && idx < count - 1) {
  //     refs[idx + 1].current.focus();
  //   } else if (!val && idx > 0) {
  //     refs[idx - 1].current.focus();
  //   }

  //   if (showError) {
  //     setShowError(false); // Remove error when user starts typing again
  //   }
  // };

  // const handleChange = (val, ref, idx) => {
  //   if (isNaN(val)) return;

  //   const digit = val.slice(-1); // Only allow one digit

  //   // Update input visually
  //   ref.current.value = digit;

  //   // Create an array from current input values
  //   const otpArray = refs.map((input) => input.current.value || "");

  //   // Update current index
  //   otpArray[idx] = digit;

  //   // Update state
  //   setOtp(otpArray.join(""));

  //   // Focus next
  //   if (digit && idx < count - 1) {
  //     refs[idx + 1].current.focus();
  //   }

  //   if (showError) {
  //     setShowError(false);
  //   }
  //   updateOtpState();
  // };

  const handleChange = (val, ref, idx) => {

    const digit = val.replace(/\D/g, "").slice(-1); // Get only the last digit, remove non-numeric

    if (!digit) {
      ref.current.value = "";
      return;
    }

    ref.current.value = digit;

    const otpArray = refs.map((r) => r.current.value || "");
    otpArray[idx] = digit;
    setOtp(otpArray.join(""));

    if (idx < count - 1) {
      refs[idx + 1].current.focus();
      // refs[idx + 1].current.select();
    }

    if (showError) setShowError(false);
    updateOtpState();
  };


  // const handleChange = (val, ref, idx) => {
  //   if (isNaN(val)) return;

  //   const digit = val.slice(-1); // Get last digit only

  //   ref.current.value = digit;

  //   const updatedOtp = [...otp];
  //   updatedOtp[idx] = digit;

  //   setOtp(updatedOtp.join(""));

  //   // Move to next input
  //   if (digit && idx < count - 1) {
  //     refs[idx + 1].current.focus();
  //   }

  //   if (showError) {
  //     setShowError(false);
  //   }
  //   updateOtpState();
  // };

  // const handleKeyDown = (e, ref, idx) => {
  //   if (e.key === "Backspace") {
  //     if (ref.current.value) {
  //       ref.current.value = "";
  //       const updatedOtp = refs.map((r) => r.current.value || "");
  //       updatedOtp[idx] = "";
  //       setOtp(updatedOtp.join(""));
  //     } else if (idx > 0) {
  //       refs[idx - 1].current.focus();
  //       setTimeout(() => {
  //         refs[idx - 1].current.setSelectionRange(1, 1);
  //       }, 0);
  //       refs[idx - 1].current.value = "";
  //       const updatedOtp = refs.map((r) => r.current.value || "");
  //       updatedOtp[idx - 1] = "";
  //       setOtp(updatedOtp.join(""));
  //     }
  //     e.preventDefault();
  //   }
     const isDigit = (k) => /^[0-9]$/.test(k);

  const handlePaste = (e, ref, idx) => {
    e.preventDefault();
    const pastedData = (e.clipboardData || window.clipboardData).getData("text");
    const digits = pastedData.replace(/\D/g, "").slice(0, 6); // Extract only digits, max 6
    
    if (!digits) return;

    // Fill OTP fields starting from the current index
    for (let i = 0; i < digits.length && (idx + i) < refs.length; i++) {
      refs[idx + i].current.value = digits[i];
    }

    // Update OTP state
    const otpArray = refs.map((r) => r.current.value || "");
    setOtp(otpArray.join(""));

    // Clear error state
    if (showError) setShowError(false);

    // Focus the next empty field or the last field if all are filled
    const nextEmptyIdx = otpArray.findIndex((digit, i) => i >= idx && digit === "");
    const focusIdx = nextEmptyIdx !== -1 ? nextEmptyIdx : Math.min(idx + digits.length, refs.length - 1);
    if (refs[focusIdx]?.current) {
      setTimeout(() => {
        refs[focusIdx].current.focus();
      }, 0);
    }
  };

  const handleKeyDown = (e, ref, idx) => {
    // console.log("key pressed", e.key, idx);
    if (isDigit(e.key)) {
      e.preventDefault();
      ref.current.value = e.key;

      const otpArray = refs.map((r) => r.current.value || "");
      otpArray[idx] = e.key;
      setOtp(otpArray.join(""));

      if (idx < count - 1) {
        refs[idx + 1].current.focus();
      }

      if (showError) setShowError(false);
      return;
    }

    if (e.key === "Backspace") {
      if (ref.current.value) {
        ref.current.value = "";
        const updatedOtp = refs.map((r) => r.current.value || "");
        updatedOtp[idx] = "";
        setOtp(updatedOtp.join(""));
      } else if (idx > 0) {
        refs[idx - 1].current.focus();
        setTimeout(() => {
          refs[idx - 1].current.setSelectionRange(1, 1);
        }, 0);
        refs[idx - 1].current.value = "";
        const updatedOtp = refs.map((r) => r.current.value || "");
        updatedOtp[idx - 1] = "";
        setOtp(updatedOtp.join(""));
      }
      e.preventDefault();
    }


    if (e.key === "ArrowLeft") {
      if (idx > 0) {
        refs[idx - 1].current.focus();
        setTimeout(() => {
          refs[idx - 1].current.setSelectionRange(1, 1);
        }, 0);
      }
      e.preventDefault(); // prevent native cursor behavior
    }

    if (e.key === "ArrowRight") {
      if (idx < count - 1) {
        refs[idx + 1].current.focus();
        setTimeout(() => {
          refs[idx + 1].current.setSelectionRange(1, 1);
        }, 0);
      }
      e.preventDefault(); // prevent native cursor behavior
    }

    if (e.key === "Enter") {
      const isOtpComplete = otp.length === count && otp.split("").every((digit) => digit !== "");
      if (isOtpComplete) {
        verifyOtp();
      }
    }
  };

  const handleClick = (idx) => {
    refs[idx].current.focus();
  };

  useEffect(() => {
    refs[0].current.focus();
  }, [refs]);
  const showToast = useToast();
  const [loading, setLoading] = useState(false);
  const verifyOtp = async () => {



    setMailData((pre) => {
      return { ...pre, otp: otp };
    });


    if (!isReset) {
      // logic for sign in organization user
      try {
        // console.log("Form data : ", formData);
        const item = await signInWithPassword({
          email: formData.individualEmail,
          password: formData.individualPassword,
          totp: otp,
          createTempPin: !addPinSelect
        });
        // Organisation instance = organisation admin; User instance: userType "User" = individual, "Employee" = organisation user
        const userType = getUserTypeFromUser(item, Organization);
        sessionStorage.setItem("usertype", getUserTypeSessionValue(item, Organization));
        setUser(item);
        if (userType === "organization") {
          setIsTypeSelect("org");
          setOrgnization(item);
        } else {
          setIsTypeSelect("individual");
        }
        const mailUser = item.getEmail();
        sessionStorage.setItem("mail", mailUser);
        setUserMail(mailUser);
        
        // Store plan name AND planId in sessionStorage after signin
        try {
          const userPlanId = item.getPlan && typeof item.getPlan === "function" ? item.getPlan() : null;
          if (userPlanId !== null && userPlanId !== undefined && userPlanId >= 0) {
            const storagePlan = new StoragePlan();
            const plansList = await storagePlan.listPlans();
            const userPlan = plansList.find(
              (p) => p.getPlanId && p.getPlanId() === userPlanId
            );
            if (userPlan) {
              const planName = userPlan.getname();
              sessionStorage.setItem("plan", planName);
              sessionStorage.setItem("planId", userPlanId.toString());
              console.log("Plan stored after signin:", planName, "planId:", userPlanId);
            }
          }
        } catch (planError) {
          console.error("Error storing plan after signin:", planError);
          // Don't block signin if plan storage fails
        }
        
        setFormData({});
        if (addPinSelect) {
          nextStep();
        } else {
          navigate("/homepage");
          window.location.reload();
        }
      } catch (error) {
        setLoading(false);
        const errorMsg = error.message?.toLowerCase() || "";
        if (errorMsg.includes("503") || errorMsg.includes("maintenance") || errorMsg.includes("failed to fetch")) {
          navigate("/maintenance");
        } else {
          showToast(error.message, "error");
        }
      }
    } else if (checkAuth) {
      // logic after reset password flow
      try {
        // console.log(mailData, "maildata", otp);
        // // const org = await wasmInstance.change_password("sing@gmail.com", "tingorg", "dummypassword", "newdummypassword", "123456", "123456");
        // const org = await wasmInstance.change_password(
        //   mailData.email,
        //   mailData.name,
        //   "",
        //   mailData.password,
        //   mailData.otp,
        //   otp
        // );
        // console.log("change password ", org);
        // setStep("");
        const user = await MU.getUserDetails();
        await user.verify("", otp);
        showToast("Totp verfifed successfully!!!");
        navigate("/signin");
        setStep("");
        setSigninSuccess(true);
      } catch (error) {
        console.error("creating error:", error, setSuccess);
        showToast(error.message, "error");
        if (error.message.toLowerCase().includes("otp")) {
          setShowError(true);
        }
      }
    }
    // }
  };

  const handleOpenMail = () => {
    navigate("/signin");
  };

  const signinHandler = () => {
    navigate("/homepage");
    window.location.reload();
  };

  const handleDashboard = () => {
    navigate("/homepage");
    window.location.reload();
  };

  return (
    <>
      {success ? (
        <Success
          title={isTypeSelect && "Signed in Successfully"}
          titleWidth="75.7%"
          titleMobileWidth="100%"
          subTitle={
            isTypeSelect &&
            "Your account has been successfully signed in. Enjoy exploring our services!"
          }
          subTitleWidth="85.2%"
          subTitleMobileWidth="100%"
          buttonText={
            isTypeSelect
              ? "Go to Home Page"
              : isReset
                ? "Back to Sign in"
                : location.state === true
                  ? "Go to Dashboard"
                  : "Done"
          }
          image={
            !isReset || !isTypeSelect || location.state === true ? "" : mailSent
          }
          imgWidth="80px"
          imgHeight="80px"
          onClick={
            isTypeSelect
              ? signinHandler
              : isReset
                ? signinHandler
                : location.state === true
                  ? handleDashboard
                  : handleOpenMail
          }
          success={true}
        />
      ) : (
        <section className="verify">
          <div className="container verifyContainer">
            <div className="verifyBox">
              <div className="commonHeading">
                <h1>{title}</h1>
                <p>{description}</p>
              </div>
              <div className="verifyCodeBox">
                <div className="otpContainer">
                  <div className="inputsWrapper" id={ids}>
                    {refs.map((ref, idx) => (
                      <input
                        ref={ref}
                        style={{
                          border:
                            showError && "1px solid var(--accent-colors-red)"
                        }}
                        maxLength={1}
                        key={`input-${idx + 1}`}
                        id={`input-${idx + 1}`}
                        name={`input-${idx + 1}`}
                        onChange={(e) => handleChange(e.target.value, ref, idx)}
                        onKeyDown={(e) => handleKeyDown(e, ref, idx)}
                        onPaste={(e) => handlePaste(e, ref, idx)}
                        onClick={() => handleClick(idx)}
                        onFocus={(e) => {
                          const input = e.target;
                          input.setSelectionRange(input.value.length, input.value.length);
                        }} // focus the current input box
                        inputMode="numeric"
                        pattern="[0-9]*"
                        type="tel"
                        placeholder=""
                      />
                    ))}
                  </div>
                  <span
                    style={{ visibility: showError ? "visible" : "hidden" }}
                    className="errorText"
                  >
                    Please enter the valid code
                  </span>
                </div>
                <Button
                  loading={loading}
                  title={btnText}
                  type="violet"

                  //   onClick={verifyOtp}
                  // onClick={showSuccess}
                  onClick={() => {
                    verifyOtp();
                  }}
                  disabled={otp.length < 6}
                />
              </div>
            </div>
          </div>
        </section>
      )}
    </>
  );
};

export default VerifyCode;
